import React, { useContext } from "react";
import { Cookies, IdentityServerReloginState, UserType } from "../types";
import { type AuthenticationAction } from "./types";

export type CoordinatorLoginConfiguration = {
    cookies: Cookies;
    reloginState: string;
    sessionCookieName: string;
    userType: string;
    hasMfaConfig: boolean;
    allowSnooze2FA: boolean;
    totpAllowRememberMe: boolean;
    totpRememberMeHours?: number;
    passkeyServerBaseUrl?: string;
    hasRecoveryCodes: boolean;
};

type Action = {
    type: "UPDATE_CONFIGURATION";
    payload: Partial<CoordinatorLoginConfiguration>;
};

export const defaultCoordinatorLoginConfiguration: CoordinatorLoginConfiguration = {
    cookies: {} as Cookies,
    reloginState: IdentityServerReloginState.None,
    sessionCookieName: "",
    userType: UserType.coordinator,
    hasMfaConfig: false,
    allowSnooze2FA: false,
    totpAllowRememberMe: false,
    hasRecoveryCodes: false,
};

export function reducer(configuration: CoordinatorLoginConfiguration, action: Action): CoordinatorLoginConfiguration {
    switch (action.type) {
        case "UPDATE_CONFIGURATION":
            return { ...configuration, ...action.payload };
        default:
            return configuration;
    }
}

export const AuthenticationConfigurationContext = React.createContext<CoordinatorLoginConfiguration>(
    defaultCoordinatorLoginConfiguration,
);
export const AuthenticationConfigurationDispatchContext = React.createContext<React.Dispatch<AuthenticationAction>>(
    () => {},
);

export const useAuthenticationConfiguration = () => useContext(AuthenticationConfigurationContext);

export const useConfiguration = () => {
    const configuration = useAuthenticationConfiguration();

    return {
        configuration,
    };
};
